"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "anzano-di-puglia": {
    "fbc39570": [{
      "hkey": "217aded2",
      "slug": "anzano-di-puglia",
      "name": "Anzano di Puglia",
      "primary": true,
      "skipSearch": false
    }],
    "rione-calabrone": [{
      "hkey": "217aded2",
      "slug": "anzano-di-puglia",
      "name": "Anzano di Puglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b9ecb46b": [{
      "hkey": "e0986b78",
      "slug": "carifano-mastralessio",
      "name": "Carifano-Mastralessio",
      "primary": true,
      "skipSearch": false
    }],
    "rione-carifano": [{
      "hkey": "e0986b78",
      "slug": "carifano-mastralessio",
      "name": "Carifano-Mastralessio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f8821d6e": [{
      "hkey": "217aded2",
      "slug": "anzano-di-puglia",
      "name": "Anzano di Puglia",
      "primary": true,
      "skipSearch": false
    }],
    "rione-lo-russo": [{
      "hkey": "217aded2",
      "slug": "anzano-di-puglia",
      "name": "Anzano di Puglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50a23e6f": [{
      "hkey": "217aded2",
      "slug": "anzano-di-puglia",
      "name": "Anzano di Puglia",
      "primary": true,
      "skipSearch": false
    }],
    "rione-lo-scialpo": [{
      "hkey": "217aded2",
      "slug": "anzano-di-puglia",
      "name": "Anzano di Puglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "79eeeaac": [{
      "hkey": "f607c39a",
      "slug": "portolecchia",
      "name": "Portolecchia",
      "primary": true,
      "skipSearch": false
    }],
    "rione-mastralessio-portolecchia": [{
      "hkey": "f607c39a",
      "slug": "portolecchia",
      "name": "Portolecchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "376885e9": [{
      "hkey": "6b4a5524",
      "slug": "nocelle-morra-pioppo-pontieri",
      "name": "Nocelle-Morra-Pioppo Pontieri",
      "primary": true,
      "skipSearch": false
    }],
    "rione-morra": [{
      "hkey": "6b4a5524",
      "slug": "nocelle-morra-pioppo-pontieri",
      "name": "Nocelle-Morra-Pioppo Pontieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "anzano-di-puglia"
    }],
    "d0ea9c68": [{
      "hkey": "6b4a5524",
      "slug": "nocelle-morra-pioppo-pontieri",
      "name": "Nocelle-Morra-Pioppo Pontieri",
      "primary": true,
      "skipSearch": false
    }],
    "rione-nocelle": [{
      "hkey": "6b4a5524",
      "slug": "nocelle-morra-pioppo-pontieri",
      "name": "Nocelle-Morra-Pioppo Pontieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "anzano-di-puglia"
    }],
    "2a89a092": [{
      "hkey": "6b4a5524",
      "slug": "nocelle-morra-pioppo-pontieri",
      "name": "Nocelle-Morra-Pioppo Pontieri",
      "primary": true,
      "skipSearch": false
    }],
    "rione-pioppo-pontieri": [{
      "hkey": "6b4a5524",
      "slug": "nocelle-morra-pioppo-pontieri",
      "name": "Nocelle-Morra-Pioppo Pontieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "anzano-di-puglia"
    }],
    "a70c74e8": [{
      "hkey": "217aded2",
      "slug": "anzano-di-puglia",
      "name": "Anzano di Puglia",
      "primary": true,
      "skipSearch": false
    }],
    "rioni-rione-casette": [{
      "hkey": "217aded2",
      "slug": "anzano-di-puglia",
      "name": "Anzano di Puglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;